import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from 'src/app/handlers/logger.service';

@Component({
  selector: 'app-document-actions',
  standalone: false,
  templateUrl: './document-actions.component.html',
  styleUrls: ['./document-actions.component.scss']
})
export class DocumentActionsComponent implements OnInit {
  reimportForm: FormGroup;

  importUuid: string;
  releaseUuid: string;
  redoCategoryUuid: string;
  selectedClient: number;
  clients: any[];

  constructor(private formBuilder: FormBuilder,
        private apiHandler: ApiService,
        private logger: LoggerService,
        private toastr: ToastrService) {

  }

  ngOnInit() {
    this.apiHandler.getABCisRequest(ABCisApi.Support, 'client/lookup').then((response) => {
      this.clients = response.body as [];
    }).catch(response => {
      this.toastr.error(response.error);
    });
  }

  releaseFiles() {
    if(this.selectedClient != undefined){
      this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/client-release?clientId=${this.selectedClient}`)
      // this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/client-release?clientId=${this.selectedClient}&minutesBefore=30`)
        .then((response) => {
          this.toastr.success('Succesfully released');
        }).catch(response => {
          this.toastr.error(response.error);
        });
    } else {
      this.toastr.warning('Please select a client');
    }
  }

  onSubmit(uuid: string, buttonType: string) {
    if (uuid != undefined && uuid != '') {
      this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${uuid}/${buttonType}`).then((response) => {
        this.toastr.success('Succesfully Reimported');
      }).catch(response => {
        this.toastr.error(response.error);
      });
    } else {
      this.toastr.warning('UUID needs to not be null');
    }
  }
}
